import _Vue from 'vue';
import GlobalAlerts from '~/components/Alerts/index.vue';
import { GlobalAlert } from './types';
import { addGlobalAlert, removeGlobalAlert } from './state';

let globalAlertsCurrentId = 0;

export function AlertsPlugin(Vue: typeof _Vue) {
  Vue.component('global-alerts', GlobalAlerts);

  // eslint-disable-next-line no-param-reassign
  Vue.prototype.$alerts = {
    add(alert: GlobalAlert): GlobalAlert {
      const id = globalAlertsCurrentId + 1;
      // eslint-disable-next-line no-param-reassign
      alert = { ...alert, id };
      addGlobalAlert(alert);
      globalAlertsCurrentId = id;
      return alert;
    },

    remove(alertId: number) {
      removeGlobalAlert(alertId);
    },
  };
}

export default AlertsPlugin;
